<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div><strong>Payable To</strong></div>
          <div>{{ check.payee  }}</div>
          <div><strong>Check to be mailed to</strong></div>
          <div>{{ map.mailTo[check.mailTo] }}</div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <div class="text-center bottom-border">
            <strong>Payee Address</strong>
          </div>
          <address-display class="mt-2" :address="check.payeeAddress"/>
        </b-col>
        <b-col v-if="check.mailTo === 'address'">
          <div class="text-center bottom-border">
            <strong>Alternate Address</strong>
          </div>
          <address-display class="mt-2" :address="check.alternateAddress"/>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import AddressDisplay from '@/components/utils/address/AddressDisplay';

export default {
  components: {
    AddressDisplay,
  },
  props: {
    check: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      map: {
        mailTo: {
          address: 'Alternate Address',
          borrower: 'Borrower',
          payee: 'Payee',
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/display/CheckDisplay.vue